import Button from '@wiggui/ds/Button'
import Flex from '@wiggui/ds/Flex'
import Modal from '@wiggui/ds/Modal'
import Text from '@wiggui/ds/Text'
import Avatar from '@wiggui/ds/Avatar'
import { MdOutlineCheck } from 'react-icons/md'
import { useCompleted } from './useCompleted'

export const Completed = () => {
  const { handleCompleted, logoUrl, invitationData, error, isLoading } =
    useCompleted()

  return (
    <>
      <Modal.Body>
        <Flex dir="col" items="center" justify="start" gap="gap-6" wFull>
          <div className="relative">
            <Avatar
              containerClassName="rounded-full min-w-[40px] min-h-[40px] w-10 h-10"
              avatarUrl={logoUrl}
              fullName={invitationData?.agencyName}
            />
            <div className="absolute bottom-0 right-0 bg-notif-green rounded-full w-[18px] h-[18px] flex items-center justify-center">
              <MdOutlineCheck className="text-white min-w-[16px] min-h-[16px]" />
            </div>
          </div>
          <Flex dir="col" items="center" justify="start" gap="gap-6" wFull>
            <Text className="text-headline-s text-primary font-semibold text-left w-full">
              Tu solicitud fue aprobada
            </Text>
            <Text className="text-secondary text-body-m text-left w-full">
              Ya puedes comenzar a utilizar las herramientas de Wiggot para tu
              agencia.
            </Text>
          </Flex>
        </Flex>
      </Modal.Body>
      <Modal.Footer className="flex-col flex py-3 border-t gap-3 border-surface-strokes items-center w-full px-6 justify-between">
        <Button
          isLoading={isLoading}
          fullWidth
          variant="secondary"
          onClick={(event) => {
            event.stopPropagation()
            handleCompleted()
          }}
        >
          {isLoading ? 'Actualizando roles...' : 'Continuar'}
        </Button>
        {error && (
          <Text className="text-notif-error w-full text-center text-body-s">
            {error}
          </Text>
        )}
      </Modal.Footer>
    </>
  )
}
